import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { StepsComponent } from './steps/steps.component';
import { ListingSwiperComponent } from './listing-swiper/listing-swiper.component';
import { ReasonsToSellComponent } from './reasons-to-sell/reasons-to-sell.component';
import { EnlistPropertyComponent } from './enlist-property/enlist-property.component';
import { ImageScrollAnimationDirective } from 'src/app/shared/directives/image-scroll-animation.directive';
import { RouterModule } from '@angular/router';
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';
import { FloatingBannerComponent } from '../../shared/components/floating-banner/floating-banner.component';

@Component({
  selector: 'app-sell-with-us',
  standalone: true,
  imports: [
    TranslocoDirective,
    StepsComponent,
    ListingSwiperComponent,
    ReasonsToSellComponent,
    RouterModule,
    EnlistPropertyComponent,
    ImageScrollAnimationDirective,
    LanguageRouterLinkDirective,
    FloatingBannerComponent,
  ],
  templateUrl: './sell-with-us.component.html',
  styleUrl: './sell-with-us.component.css',
})
export class SellWithUsComponent {}
